import * as speakers from './speakers';
import * as crossfade from './crossfade';
const tickets = 'https://tedxportland2019.eventbrite.com'
export { speakers, tickets, crossfade };
